__webpack_require__.p = "/wp-content/themes/gutenify-exosphere/react-apps/";